module.exports = __webpack_public_path__ + "img/loading.dfa75fd1.svg";